module.exports = __webpack_public_path__ + "static/images/prize.78cc669.png";